import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useGetBundle } from "@/requests/gen/react-query/bundle";
import { BundleCrumbs } from "../../-crumbs";
import BundleProductsForm from "./-form";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_patient-360/bundle/$bundleId/products/",
)({
  component: BundleProductsPage,
});

function BundleProductsPage() {
  const { bundleId } = Route.useParams();
  const { data: bundle, isLoading } = useGetBundle(numericId(bundleId));

  return (
    <div>
      <title>{`${bundle?.name} Products - Legrande Health Portal`}</title>
      <BundleCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>{isLoading ? "Loading..." : "Products"}</CardTitle>
          <CardDescription>
            Add or modify the products that make up this bundle.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {!isLoading && bundle && <BundleProductsForm bundle={bundle} />}
        </CardContent>
      </Card>
    </div>
  );
}
